import React, {PureComponent} from "react"

import {H2} from "@irati/ui/src/Headings"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"
import Flex from "@irati/ui/src/Flex"
import TenantBadgeImage from "../../images/wallet_blue_badge.svg"

import {IntroText} from "../IntroText"
import Image from "../styled/Image"

class TenantWalletIntro extends PureComponent {
  render() {
    const tenantName = authentication.userTenant().public_name

    return (
      <>
        <Flex alignItems="center">
          <Image src={TenantBadgeImage} alt="Tenant Wallet Badge" />
          <H2><FormattedMessage id="wallet.tenant.intro.header" values={{tenantName}} /></H2>
        </Flex>
        <IntroText message="wallet.tenant.intro.text" tenantName={tenantName} />
      </>
    )
  }
}

export default TenantWalletIntro
